import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@heidi/design-system/alert-dialog';
import { TypographyP, TypographyP2 } from '@heidi/design-system/typography';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  title: {
    defaultMessage: 'Let Heidi approve for you?',
    id: 'xEBw+a4Xel',
    description: 'Title of the warning shown before enabling Approve for me',
  },
  intro: {
    defaultMessage:
      'Heidi will work on its own but ask you before taking sensitive actions, like deleting patient data.',
    id: '5vvkBnFHFL',
    description: 'Introduction to the Approve for me warning',
  },
  persistence: {
    defaultMessage:
      'All new chats will use this setting. You can change this setting at any time.',
    id: 'NO5dxECEJc',
    description: 'Persistence note in the Approve for me warning',
  },
  cancel: {
    defaultMessage: "Don't use",
    id: 'dtYinCtDCR',
    description: 'Button that leaves Ask for approval enabled',
  },
  confirm: {
    defaultMessage: 'Use Approve for me',
    id: 'qhstxNHxOJ',
    description: 'Button that confirms Approve for me',
  },
});

interface AutoApproveDisclaimerDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

/** User-triggered safety confirmation. It is not a launch modal. */
export function AutoApproveDisclaimerDialog({
  open,
  onOpenChange,
  onConfirm,
}: AutoApproveDisclaimerDialogProps): JSX.Element {
  const intl = useIntl();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="auto-approve-disclaimer">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-balance">
            {intl.formatMessage(messages.title)}
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="flex flex-col gap-3 text-pretty text-start">
              <TypographyP>{intl.formatMessage(messages.intro)}</TypographyP>
              <TypographyP2 className="text-text-tertiary">
                {intl.formatMessage(messages.persistence)}
              </TypographyP2>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{intl.formatMessage(messages.cancel)}</AlertDialogCancel>
          <AlertDialogAction
            data-testid="auto-approve-disclaimer-confirm"
            onClick={onConfirm}
          >
            {intl.formatMessage(messages.confirm)}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
